import { RoutingPath } from "src/app/configs/routing-path";

export class Responses {
  public static Message = [
      { code: '201',
        message:'El usuario que está consultando no se encuentra <br> afiliado con su empresa',
        urlBack: '/',
        urlNext: RoutingPath.appRouting.components.individual_retreat.path+'/'+RoutingPath.appRouting.components.individual_retreat.pages.home.path,
        textNext: "Volver al Inicio",
        textBack:"Buscar"
      },
      {
        code: '500',
        message: 'Se han presentado inconvenientes con tu solicitud,<br>debes reintentar mas tarde.'
      },
      {
        code: '501',
        message: 'Se han presentado inconvenientes con tu solicitud,<br>debes reintentar mas tarde.',
        urlBack: '/',
        urlNext: RoutingPath.appRouting.components.workers_information.path,
        textNext: "Volver al Inicio",
        textBack:"Nueva solicitud"
      },
      {
        code: '502',
        message: 'El trabajador ya tiene una solicitud en proceso',
        urlNext: RoutingPath.appRouting.components.workers_information.path +'/'+RoutingPath.appRouting.components.workers_information.pages.consult_worker.path,
        urlBack: RoutingPath.appRouting.components.individual_retreat.pages.home.path,
        textNext: "Volver al Inicio",
        textBack:"Buscar"
      },
      {
        code: '503',
        message: 'El trabajador ya tiene una solicitud en proceso',
        urlNext: RoutingPath.appRouting.components.workers_information.path +'/'+RoutingPath.appRouting.components.workers_information.pages.consult_worker.path,
        urlBack: RoutingPath.appRouting.components.workers_information.pages.home.path,
        textNext: "Volver al Inicio",
        textBack:"Buscar"
      },
      //se crea um nuevo codigo para urlnext
      {
        code: '504',
        message: 'Se han presentado inconvenientes con tu solicitud,<br>debes reintentar mas tarde.',
        urlBack: '/',
        urlNext:RoutingPath.appRouting.components.workers_information.path +'/'+RoutingPath.appRouting.components.workers_information.pages.consult_worker.path,
        textNext: "Volver al Inicio",
        textBack:"Nueva solicitud"
      },

  ]
}
